import * as React from 'react';
import { SVGProps } from 'react';

const IconLightningBoltSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 0H5.5L3 10l3.361-.747L4 16h.5L13 5l-3.85.7L12 0z" />
  </svg>
);
export default IconLightningBoltSizeS;
